import React, {Component} from 'react';
import ServiceItem from './ServiceItem';

const services = [
  {
    imageSrc: 'icon-ipoteka',
    textTitle: 'Ипотека',
    text: 'Заполните анкету и получите одобрение через 2 минуты',
    buttonText: 'Подробнее',
    buttonLink: 'https://cian.ru/ipoteka-main/?utm_source=mlsn&utm_medium=trap&utm_campaign=services&utm_content=mortgage_rates&utm_term=main&platform=desk'
  },
  {
    imageSrc: 'icon-rieltor',
    textTitle: 'Подбор риелтора',
    text: 'Риелтор поможет купить или продать любую недвижимость',
    buttonText: 'Оставить заявку',
    buttonLink: 'https://cian.ru/application-form/?utm_source=mlsn&utm_medium=referral&utm_campaign=podbor_rieltora_glavnaya'
  },
  {
    imageSrc: 'icon-ocenka',
    textTitle: 'Оценка квартиры',
    text: 'Рассчитаем стоимость квартиры на основе тысяч похожих объявлений',
    buttonText: 'Оценить',
    buttonLink: 'https://www.cian.ru/kalkulator-nedvizhimosti/?utm_source=mlsn&utm_medium=referral&utm_campaign=services'
  }
];

class ServicesMenu extends Component {
  renderServices () {
    return (
      <div className='services-section-content list-inline'>
        {
          services.map((item, itemIndex) => {
            return (
              <ServiceItem
                index={itemIndex}
                imageSrc={item.imageSrc}
                textTitle={item.textTitle}
                text={item.text}
                buttonLink={item.buttonLink}
                buttonText={item.buttonText}
              />
            );
          })
        }
      </div>
    );
  }

  render () {
    return (
      <div className='services-section'>
        <h2 className='services-title'>МЛСН и Циан — теперь одна компания!</h2>
        <p className='services-subtitle'>
          Переходите на Циан: больше продуктов для выбора недвижимости
        </p>
        {this.renderServices()}
      </div>
    );
  }
}

ServicesMenu.propTypes = {};
ServicesMenu.defaultProps = {};

export default ServicesMenu;



// WEBPACK FOOTER //
// ./src/ui/Menu/ServicesMenu.jsx